import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  z-index: 1300;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(33, 41, 52, 0.32);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Modal = styled.div`
  background: #fff;
  border-radius: 12px;
  width: 850px;
  max-width: 95vw;
  box-shadow: 0 8px 32px rgba(33, 41, 52, 0.16);
  padding: 24px;
  position: relative;
  font-family: "Manrope", sans-serif;
  z-index: 1400;
  display: flex;
  flex-direction: column;
  overflow: visible;
`;

export const CloseButton = styled.div`
  position: absolute;
  right: 24px;
  top: 24px;
  background: none;
  border: none;
  font-size: 20px;
  color: #aeb8c4;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  &:hover {
    background-color: #f3f4f7;
  }
`;

export const ModalTitle = styled.div`
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #1b2028;
  margin-bottom: 8px;
  padding-right: 40px;
`;

export const FileCountText = styled.div`
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #5A6C87;
  margin-bottom: 16px;
`;

export const FileListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
  overflow: visible;
`;

export const FileItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const FileNumber = styled.span`
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #1B2028;
  min-width: 24px;
  flex-shrink: 0;
`;

export const FileItemBox = styled.div`
  flex: 1;
  background: #F3F4F7;
  border: 1px solid #DDE2E9;
  border-radius: 6px;
  padding: 7px 8px;
  display: flex;
  align-items: center;
`;

export const FileItemContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
`;

export const DragHandle = styled.span`
  cursor: grab;
  color: #B0B7C3;
  font-size: 18px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: auto;

  &:active {
    cursor: grabbing;
  }
`;

export const FileItemName = styled.div`
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: #1B2028;
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
  background: #ffffffff;
  padding:8px;
`;

export const FileItemSize = styled.span`
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #5A6C87;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  flex-shrink: 0;
  transition: background-color 0.2s;
  margin-left: 8px;

  &:hover {
    background-color: #F3F4F7;
  }

  &:active {
    background-color: #E3E6E8;
  }
`;

export const AddFilesButton = styled.button`
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #0C53BB;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px 0;
  text-align: left;
  margin-bottom: 16px;
  transition: color 0.2s;

  &:hover {
    color: #084080;
    text-decoration: underline;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #f3f4f7;
`;

export const CancelButton = styled.button`
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0;
  border-radius: 6px;
  border: 1px solid #dde2e9;
  background: #f3f4f7;
  color: #1b2028;
  padding: 10px 12px;
  min-width: 68px;
  height: 32px;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: #e3e6e8;
  }
`;

export const CombineButton = styled.button`
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0;
  border-radius: 6px;
  border: none;
  background: #0c53bb;
  color: #fff;
  padding: 10px 12px;
  min-width: 68px;
  height: 32px;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  &:hover {
    background: ${(props) => (props.disabled ? "#0c53bb" : "#084080")};
  }
`;


export const OutputNameRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 16px;
`;

export const OutputNameLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #48566b;
`;

export const OutputNameInput = styled.input`
  border: 1px solid #d4dbe3;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
  font-family: "Manrope", sans-serif;
  color: #212934;
  outline: none;

  &:focus {
    border-color: #0c53bb;
  }

  &::placeholder {
    color: #aeb8c4;
  }
`;
